import * as Sentry from '@sentry/react';

// Supervision des erreurs frontend.
// Ne s'active que si REACT_APP_SENTRY_DSN est définie au moment du build
// (variable d'environnement Railway / CI) — en local, rien ne part.
const DSN = process.env.REACT_APP_SENTRY_DSN;

export const sentryActif = Boolean(DSN);

export function initSentry() {
    if (!sentryActif) return;

    Sentry.init({
        dsn: DSN,
        environment: process.env.NODE_ENV,
        // Traces de performance : 10 % des navigations suffisent pour
        // repérer les pages lentes sans consommer le quota.
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.1,
        // RGPD : pas d'IP ni de données par défaut, on n'attache que l'id interne.
        sendDefaultPii: false,
        // Bruit connu qui n'est pas un bug de l'application :
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            'Network Error',
            'Failed to fetch',
            'Load failed',
            'AbortError',
            // Session expirée → redirection login déjà gérée par l'intercepteur axios
            'Request failed with status code 401',
        ],
        beforeSend(event) {
            // Ceinture et bretelles : on retire toute URL contenant un mot de passe.
            if (event.request?.url?.includes('password')) return null;
            return event;
        },
    });

    // Contexte utilisateur : uniquement l'id interne (pas d'email, pas de nom).
    try {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        if (user?.id) Sentry.setUser({ id: String(user.id) });
    } catch { /* localStorage corrompu → contexte anonyme */ }
}

// À appeler après connexion / déconnexion pour tenir le contexte à jour.
export function setSentryUser(user) {
    if (!sentryActif) return;
    Sentry.setUser(user?.id ? { id: String(user.id) } : null);
}
